/**
 * The Connaro mark: a double concentric arc of connected nodes forming an open
 * "C", in the brand gradient (#0A84FF → #7A3CFF). Each arc ends in a short
 * angular "circuit step" to a terminal node on the right. Per the brand system
 * the mark supplies the letter "C", and the wordmark alongside it spells the rest
 * ("onnaro"). Labelled "Connaro" so assistive tech reads the whole name, not "C".
 * Geometry matches the brand assets in public/brand/.
 */
export function Logo({ className = 'brand__mark' }: { className?: string }): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 120 120"
      role="img"
      aria-label="Connaro"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Connaro</title>
      <defs>
        <linearGradient id="connaro-mark" x1="24" y1="16" x2="86" y2="104" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0A84FF" />
          <stop offset="0.55" stopColor="#4E63FF" />
          <stop offset="1" stopColor="#7A3CFF" />
        </linearGradient>
      </defs>
      <g stroke="url(#connaro-mark)" strokeLinecap="round" strokeLinejoin="round">
        <path d="M98 33 L82 22 A44 44 0 1 0 82 98 L98 87" strokeWidth="4.8" />
        <path d="M86 45 L72 36 A27 27 0 1 0 72 84 L86 75" strokeWidth="4.4" />
      </g>
      <g stroke="url(#connaro-mark)" strokeWidth="3.8">
        <circle cx="98" cy="33" r="7" />
        <circle cx="44" cy="19" r="6.5" />
        <circle cx="19" cy="44" r="6.5" />
        <circle cx="19" cy="76" r="6.5" />
        <circle cx="44" cy="101" r="6.5" />
        <circle cx="98" cy="87" r="7" />
        <circle cx="86" cy="45" r="6" />
        <circle cx="43" cy="39" r="5.5" />
        <circle cx="33" cy="60" r="5.5" />
        <circle cx="43" cy="81" r="5.5" />
        <circle cx="86" cy="75" r="6" />
      </g>
    </svg>
  );
}
